<template>
    <div class="ranking-box">
        <div class="title-box">
            <p>排行</p>
            <p>{{type||'课程'}}名称</p>
            <p>{{title||'学习次数'}}</p>
            <p>占比</p>
        </div>
        <div class="data-box">
            <div v-for="(item,index) in dataList" class="data-item" :key="index">
                <div class="rank-serial">{{ index+1 }}</div>
                <div class="percent-box">
                    <div class="rank-word">
                        <el-tooltip class="item" effect="dark" :content="item.courseName" placement="top-start">
                            <p class="overflow name-p">{{ item.courseName }}</p>
                        </el-tooltip>
                        <countTo class="count-to" :startVal="0" :endVal="item.studyNumberCount" :duration="3000"></countTo>
                        <p class="percent">{{ getPercent(item.studyNumberCount,totalStudyCount)+'%' }}</p>
                    </div>
                    <div class="over-progress">
                        <div :style="`width:${getPercent(item.studyNumberCount,totalStudyCount)}%;`" class="progress"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['title','type'],
        data(){
            return {
                dataList:[],
                totalStudyCount:0
            }
        },
        methods:{
            getPercent(num,total){
                var number=num/total*100
                return parseFloat(number.toFixed(2));
            }
        }
    }
</script>

<style lang="less" scoped>
.name-p{
    width: 15rem;
}
.ranking-box{
    .title-box{
        display: flex;
        color: #334681;
        margin-bottom: 1rem;
        margin-top: 2rem;
        position: relative;
        height: 2rem;
        &> :nth-child(n){
            position: absolute;
        }
        &> :nth-child(2){
            left: 5.5rem;
        }
        &> :nth-child(3){
            left: 50%;
            // transform: translateX(-50%);
        }
        &> :nth-child(4){
            left: 100%;
            transform: translateX(-100%);
        }
    }
}
.percent-box{
    width: 100%;
}
.data-box{
    &> :nth-child(n){
        margin-top: 3rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}
.data-item{
    display: flex;
    align-items: flex-end;
}
.rank-serial{
    font-size: 16px;
    color: #334681;
    width: 3rem;
    height: 3rem;
    background-color: #ECF2FF;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.over-progress{
    // width: 42rem;
    width: calc(100% - 3rem);
    height: 10px;
    background: #eef0f5;
    border-radius: 5px;
    margin-left: 2.9rem;
    position: relative;
    margin-top: 0.8rem;
    .progress{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: linear-gradient(-90deg,#72bbff 0%, #387dff 100%);
        border-radius: 5px;
    }
}
.rank-word{
    display: flex;
    position: relative;
    height: 2rem;
    &> :nth-child(n){
        position: absolute;
    }
    &> :nth-child(1){
        font-size: 14px;
        color: #334681;
        left: 2.8rem;
    }
    &> :nth-child(2){
        font-size: 12px;
        color: #387DFF;
        left: 50%;
        // transform: translateX(-50%);
        width: 10rem;
    }
    &> :nth-child(3){
        font-size: 14px;
        color: #387DFF;
        font-weight: 700;
        left: 100%;
        transform: translateX(-100%);
    }
}
@media screen and (max-width: 750px) {
    .over-progress{
        margin-left: 1rem !important;
        width: calc(100% - 1rem) !important;
    }
}
</style>